import request from './request';
import BanModel from '../models/ban';

type GetAllBansResponse = {
  success: boolean;
  bans: BanModel[];
  message?: string;
};

const banService = {
  userSaleGetAllBan: async (): Promise<BanModel[]> => {
    const response = await request.get<GetAllBansResponse>(
      'user-sale-get-all-ban'
    );
    const result = response.data;

    if (!result.success) {
      throw new Error(result.message || 'Không thể tải danh sách bàn');
    }

    return result.bans;
  },
};

export default banService;